


// import React, { useState, useEffect } from "react";
// import image from "../../../images/aaaservices/h.png"; // Update your actual image path
// import scannerImg from "../../../images/qr-code.png";
// import wrapImage from "../../../images/aaaservices/food.avif"; // adjust path as per your folder structure
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import "./auth.css";

// const Auth = () => {
//     const [showPopup, setShowPopup] = useState(false);
//     const [showForgetPassword, setShowForgetPassword] = useState(false);
//     const [isForgot, setIsForgot] = useState(false);
//     const [loginObj, setLoginObj] = useState({
//         userName: "",
//         password: "",
//     });
//     const [hidePassword, setHidePassword] = useState(true);
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState("");
//     const navigate = useNavigate();
//     const [showPasswordFields, setShowPasswordFields] = useState(false);
//     const [forgotEmail, setForgotEmail] = useState("");
//     const [email, setEmail] = useState("");
//     const [message, setMessage] = useState("");
//     const [showLogin, setShowLogin] = useState(false);
//     const [isSignup, setIsSignup] = useState(false);
//     const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
//     // const [loginStepStarted, setLoginStepStarted] = useState(false);
//     const [emailCheckMessage, setEmailCheckMessage] = useState("");
//     const [loading, setLoading] = useState(false);

//     const [showPassword, setShowPassword] = useState(false);
//     // Add this to your Auth component's useEffect
//     useEffect(() => {
//         const handleOpenLogin = () => {
//             setShowLogin(true);
//         };

//         window.addEventListener('openLoginPanel', handleOpenLogin);

//         return () => {
//             window.removeEventListener('openLoginPanel', handleOpenLogin);
//         };
//     }, []);

//     // ise change karke aisa karo 👇
//     const [loginStepStarted, setLoginStepStarted] = useState(true);
//     const handleResetPassword = async () => {
//         if (!email) {
//             alert("Please enter your email");
//             return;
//         }

//         try {
//             const response = await fetch(
//                 `https://backend.maamaas.com/subscription/api/auth/vendor/reset-password?identifier=${encodeURIComponent(email)}`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         Accept: "*/*",
//                     },
//                 }
//             );

//             const data = await response.json();

//             if (!response.ok) {
//                 throw new Error(data.message || "Password reset failed");
//             }

//             // console.log("✅ Password reset success:", data);
//             alert("Password reset link has been sent!");
//         } catch (err) {
//             console.error("❌ Error resetting password:", err);
//             alert("Reset Password send to mailId!");
//         }
//     };
//     const handleEmailCheck = async (e) => {
//         e.preventDefault();
//         const email = loginObj.emailId?.trim();

//         if (!email) {
//             alert("Please enter a valid email.");
//             return;
//         }

//         try {
//             const response = await axios.get(
//                 `https://backend.maamaas.com/subscription/vendor-enquiries/get-email`,
//                 {
//                     params: { emailId: email },
//                 }
//             );

//             console.log("✅ API Full Response:", response.data);
//             const vendorData = response.data;

//             if (vendorData?.vendorId) {
//                 localStorage.setItem("vendorId", vendorData.vendorId);
//                 alert("✅ Email verified and vendor ID stored.");
//                 navigate("/foodladingpage");
//             } else {
//                 console.warn("⚠️ No vendorId found in API response.");
//                 alert("Vendor not found. Please try again.");
//             }
//         } catch (error) {
//             console.error("❌ Error during email check:", error.response?.data || error.message);
//             alert("Failed to check email. Please try again.");
//         }
//     };

//     const handleChange = (e) => {
//         setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
//     };

//     const handleSignup = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         setError("");

//         const requestBody = {
//             userName: loginObj.userName,
//             emailId: loginObj.emailId,
//             password: loginObj.password,
//             mobileNumber: loginObj.mobileNumber,
//             role: "ADMIN",
//         };

//         alert(`Role being sent: ${requestBody.role}`);

//         const apiUrl =
//             "http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/user/registration";

//         try {
//             const response = await fetch(apiUrl, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(requestBody),
//             });

//             if (response.ok) {
//                 alert("Signup successful!");
//                 navigate("/home");
//                 setIsSignup(false);
//                 setIsForgot(false);
//             } else {
//                 const result = await response.json();
//                 setError(result.message || "Signup failed");
//             }
//         } catch (error) {
//             setError("Something went wrong. Please try again.");
//         }

//         setIsLoading(false);
//     };

//     const handleChanges = (e) => {
//         const { name, value } = e.target;
//         setLoginObj((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     const handleLogin = async (e) => {
//         e.preventDefault();
//         setIsLoading(true);
//         setError("");

//         try {
//             const url = `https://backend.maamaas.com/subscription/api/auth/login/vendor?identifier=${encodeURIComponent(
//                 loginObj.userName
//             )}&password=${encodeURIComponent(loginObj.password)}`;

//             const response = await fetch(url, {
//                 method: "POST",
//                 headers: { Accept: "*/*" },
//                 body: "", // matches curl -d ''
//             });

//             const data = await response.json();

//             if (!response.ok) {
//                 throw new Error(data.message || "Login failed");
//             }

//             console.log("✅ Login API response:", data);

//             // Clear previous login data
//             localStorage.clear();

//             // Store fields
//             localStorage.setItem("authToken", data.token || "");
//             localStorage.setItem("refreshToken", data.refreshToken || "");
//             localStorage.setItem("userId", data.userId?.toString() || "");
//             localStorage.setItem("vendorId", data.vendorId?.toString() || "");
//             localStorage.setItem("role", data.role || "");
//             localStorage.setItem("employeRole", data.employeRole || "");
//             localStorage.setItem("employeeId", data.employeeId?.toString() || "");

//             // Store planTypes as JSON string
//             if (Array.isArray(data.planTypes)) {
//                 localStorage.setItem("planTypes", JSON.stringify(data.planTypes));
//                 console.log("📦 Stored planTypes:", data.planTypes);
//             } else {
//                 localStorage.setItem("planTypes", JSON.stringify([]));
//             }

//             // Store businessVerticals as JSON
//             if (Array.isArray(data.businessVerticals)) {
//                 localStorage.setItem("businessVerticals", JSON.stringify(data.businessVerticals));
//             } else {
//                 localStorage.setItem("businessVerticals", JSON.stringify([]));
//             }

//             // Optional: store full response
//             localStorage.setItem("loginResponse", JSON.stringify(data));

//             // Navigate after login
//             navigate("/foodladingpage");

//         } catch (err) {
//             console.error("❌ Login error:", err);
//             setError("Login failed: " + err.message);
//         } finally {
//             setIsLoading(false);
//         }
//     };




//     const handleEmailChange = (event) => {
//         setEmail(event.target.value);
//     };

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         setLoading(true);
//         setMessage("");

//         try {
//             const response = await fetch(
//                 "http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/forgot/password",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Accept: "*/*",
//                     },
//                     body: JSON.stringify({ identifier: email }),
//                 }
//             );

//             const text = await response.text();
//             if (!response.ok) {
//                 throw new Error(text || "Something went wrong.");
//             }

//             setMessage("Password reset email sent successfully!");
//             setShowPasswordFields(true);
//             setIsEmailSubmitted(true);
//         } catch (error) {
//             setMessage(error.message || "Something went wrong. Try again later.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const togglePopup = () => {
//         setShowPopup(!showPopup);
//     };

//     const styles = {
//         appContainer: {
//             display: 'flex',
//             flexDirection: 'column',
//             minHeight: '100vh',
//             backgroundColor: "#2a0947",
//         },
//         navBar: {
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             padding: '15px 20px',
//             backgroundColor: "#2a0947",
//             zIndex: 1000,
//             boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//         },
//         logo: {
//             fontSize: '30px',
//             fontWeight: 'bold',
//             fontFamily: 'roboto',
//             color: '#ffe124',
//             margin: 0,
//         },
//         signInButton: {
//             backgroundColor: 'rgb(255 225 36)',
//             color: 'black',
//             fontSize: '20px',
//             fontFamily: 'Lato, sans-serif',
//             fontWeight: 'bold',
//             borderRadius: '16px',
//             width: '90px',
//             height: '40px',
//             border: 'none',
//             cursor: 'pointer',
//         },
//         contentContainer: {
//             marginTop: '80px', // Push content below fixed navbar
//             padding: '20px',
//             flex: 1,
//         },
//         topText: {
//             textAlign: 'center',
//             marginBottom: '40px',
//             marginTop: '20px',
//         },
//         topH2: {
//             fontSize: '50px',
//             marginBottom: '10px',
//             fontWeight: 'bold',
//             color: 'white',
//         },
//         topP: {
//             fontSize: '50px',
//             fontWeight: 'bold',
//             color: 'white',
//         },
//         downloadBtn: {
//             backgroundColor: '#ffe124',
//             color: 'rgb(42 9 71)',
//             padding: '12px 25px',
//             fontSize: '20px',
//             border: 'none',
//             borderRadius: '8px',
//             cursor: 'pointer',
//             transition: '0.3s ease',
//             fontWeight: 'bold',
//             marginTop: '20px',
//         },
//         mainContent: {
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             gap: '20px',
//             marginBottom: '40px',
//             flexWrap: 'wrap',
//         },
//         textSection: {
//             flex: 1,
//             minWidth: '280px',
//         },
//         textH3: {
//             fontSize: '30px',
//             marginBottom: '30px',
//             color: 'white',
//             fontWeight: 'bold',
//             textAlign: 'left',
//         },
//         textP: {
//             fontSize: '20px',
//             color: 'white',
//             textAlign: 'left',
//             fontWeight: 'bold',
//             fontFamily: 'revert',
//         },
//         imageSection: {
//             flex: 1,
//             textAlign: 'center',
//             marginTop: '40px',
//         },
//         image: {
//             width: '100%',
//             maxWidth: '600px',
//             height: 'auto',
//             borderRadius: '10px',
//         },
//         popupOverlay: {
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             background: 'rgba(0, 0, 0, 0.5)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 1000,
//         },
//         popupInner: {
//             background: 'white',
//             padding: '30px',
//             borderRadius: '10px',
//             textAlign: 'center',
//             position: 'relative',
//             maxWidth: '400px',
//             animation: 'slideUp 0.4s ease',
//             zIndex: 1001,
//         },
//         closeBtn: {
//             position: 'absolute',
//             top: '10px',
//             right: '15px',
//             fontSize: '20px',
//             background: 'none',
//             border: 'none',
//             cursor: 'pointer',
//         },
//         scannerImg: {
//             width: '200px',
//             height: 'auto',
//             marginBottom: '15px',
//         },
//         loginPopup: {
//             position: 'fixed',
//             top: 75,
//             right: showLogin ? '0' : '-100%',
//             width: '100%',
//             maxWidth: '400px',
//             // height: '60vh',
//             backgroundColor: 'white',
//             borderRadius: '20px',
//             padding: '40px 30px',
//             boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.1)',
//             transition: 'right 0.5s ease-in-out',
//             zIndex: 999,
//             display: 'flex',
//             flexDirection: 'column',
//             gap: '20px',
//             overflowY: 'auto',
//         },
//         // Responsive styles
//         '@media (max-width: 1024px)': {
//             topH2: {
//                 fontSize: '42px',
//             },
//             topP: {
//                 fontSize: '42px',
//             },
//             textH3: {
//                 fontSize: '26px',
//             },
//         },
//         '@media (max-width: 768px)': {
//             navBar: {
//                 padding: '10px 15px',
//             },
//             logo: {
//                 fontSize: '24px',
//             },
//             signInButton: {
//                 fontSize: '16px',
//                 width: '80px',
//                 height: '35px',
//             },
//             topH2: {
//                 fontSize: '32px',
//             },
//             topP: {
//                 fontSize: '32px',
//             },
//             textH3: {
//                 fontSize: '22px',
//                 marginLeft: '0',
//                 textAlign: 'center',
//             },
//             textP: {
//                 fontSize: '16px',
//                 textAlign: 'center',
//             },
//             mainContent: {
//                 flexDirection: 'column',
//             },
//             image: {
//                 height: 'auto',
//             },
//             loginPopup: {
//                 maxWidth: '90%',
//                 height: '70vh',
//             },
//         },
//         '@media (max-width: 480px)': {
//             topH2: {
//                 fontSize: '28px',
//             },
//             topP: {
//                 fontSize: '28px',
//             },
//             downloadBtn: {
//                 padding: '10px 20px',
//                 fontSize: '18px',
//             },
//             textH3: {
//                 fontSize: '20px',
//             },
//         },
//     };

//     return (
//         <div style={styles.appContainer}>
//             {/* Fixed Navigation Bar */}
//             <div style={styles.navBar}>
//                 <div style={styles.logo}>MAAMAA'S</div>
//                 {/* <button
//                     style={styles.signInButton}
//                     onClick={() => setShowLogin(true)}
//                 >
//                     Signin
//                 </button> */}
//             </div>

//             {/* Scrollable Content */}
//             <div style={styles.contentContainer}>
//                 <div style={styles.topText}>
//                     <p style={styles.topH2}>Welcome to Maamaas – Go Digital</p>
//                     <p style={styles.topP}>Earn Fully. Stay in Control.</p>
//                     <button style={styles.downloadBtn} onClick={togglePopup}>
//                         Download App
//                     </button>

//                     {showPopup && (
//                         <div style={styles.popupOverlay}>
//                             <div style={styles.popupInner}>
//                                 <button style={styles.closeBtn} onClick={togglePopup}>
//                                     ×
//                                 </button>
//                                 <img
//                                     src={scannerImg}
//                                     alt="QR Code Scanner"
//                                     style={styles.scannerImg}
//                                 />
//                                 <p>Scan the QR code to download the Maamaas App!</p>
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 <div style={styles.mainContent}>
//                     <div style={styles.textSection}>
//                         <p style={styles.textH3}>
//                             At Maamaas, we believe every business deserves the chance to grow — without heavy commissions, hidden costs, or complicated technology. That’s why we built India’s first zero-commission digital growth platform — designed to put your business in the spotlight while keeping you in full control of your earnings.
//                         </p>
//                         <p style={{
//                             textAlign: "justify",
//                             fontSize: "18px",
//                             lineHeight: "1.8",
//                             fontFamily: "Roboto, sans-serif",
//                             fontWeight: "400",
//                             margin: "0 auto",
//                             width: "90%",
//                             color: "white",
//                         }}>
//                             Step into the digital world effortlessly. With Maamaas, you can create a professional presence that showcases your services, menus, and branding. You’ll be discoverable by customers in your area and beyond, and manage everything from bookings to payments in one simple platform. No middlemen, no restrictions  just pure growth, on your terms.<br /> <br />Whether you’re serving delicious meals, offering essential services, or powering logistics, Maamaas is designed to make your business smarter, stronger, and more profitable.
//                             {/* <br></br>  ✅ Digitally showcase your restaurant with a professional presence<br />
//               ✅ Get instant visibility without needing a website or separate POS system<br />
//               ✅ Receive and manage dine-in, takeaway, and delivery orders in one place<br />
//               ✅ Generate digital bills directly to customers' phones<br />
//               ✅ Track your accounts and sales on your mobile easily<br />
//               ✅ Accept orders using any Android/iOS device or laptop — no extra hardware needed */}
//                         </p>
//                     </div>
//                     <div style={styles.imageSection} className="image-lading-build">
//                         <img src={image} alt="Learning" style={styles.image} />
//                     </div>
//                 </div>
//             </div>

//             {/* Login Popup */}
//             <div style={{
//                 ...styles.loginPopup,
//                 right: showLogin ? '0' : '-100%',
//             }}>
//                 <button
//                     style={{
//                         position: 'absolute',
//                         top: '15px',
//                         right: '20px',
//                         fontSize: '28px',
//                         background: 'none',
//                         border: 'none',
//                         color: '#333',
//                         cursor: 'pointer',
//                     }}
//                     onClick={() => {
//                         setShowLogin(false);
//                         setIsForgot(false);
//                         setIsSignup(false);
//                     }}
//                 >
//                     &times;
//                 </button>

//                 <p style={{
//                     marginBottom: 0,
//                     fontFamily: 'revert',
//                     fontSize: '22px',
//                     color: '#2a0947',
//                     fontWeight: 'bold',
//                 }}>
//                     WELCOME TO MAAMAA'S
//                 </p>

//                 {/* Login Form */}
//                 {!loginStepStarted && !isForgot && (
//                     <>
//                         <form onSubmit={handleEmailCheck} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                             <input
//                                 type="email"
//                                 placeholder="Enter your Email to Start"
//                                 name="emailId"
//                                 value={loginObj.emailId}
//                                 onChange={handleChange}
//                                 required
//                                 style={{
//                                     padding: '10px',
//                                     fontSize: '16px',
//                                     border: '1px solid #ccc',
//                                     borderRadius: '6px',
//                                 }}
//                             />
//                             <button
//                                 type="submit"
//                                 style={{
//                                     backgroundColor: 'rgb(42 9 71)',
//                                     color: 'white',
//                                     fontWeight: 'bold',
//                                     padding: '12px',
//                                     border: 'none',
//                                     borderRadius: '6px',
//                                     cursor: 'pointer',
//                                 }}
//                             >
//                                 Check & Save
//                             </button>
//                         </form>

//                         {emailCheckMessage && <p style={{ marginTop: '10px', color: 'green' }}>{emailCheckMessage}</p>}
//                         <p style={{ marginTop: '10px', fontSize: '14px' }}>
//                             Already signed up?{' '}
//                             <span
//                                 onClick={() => {
//                                     setIsSignup(false);
//                                     setLoginStepStarted(true);
//                                 }}
//                                 style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
//                             >
//                                 Login here
//                             </span>
//                         </p>
//                     </>
//                 )}

//                 {/* Login Form */}
//                 {!isForgot && loginStepStarted && (
//                     <>
//                         <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//                             <input
//                                 type="text"
//                                 placeholder="User ID"
//                                 name="userName"
//                                 value={loginObj.userName}
//                                 onChange={handleChanges}
//                                 style={{
//                                     padding: '10px',
//                                     fontSize: '16px',
//                                     border: '1px solid #ccc',
//                                     borderRadius: '6px',
//                                 }}
//                             />
//                             {/* <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
//                 <input
//                   type={showPassword ? 'password' : 'text'}
//                   placeholder="Password"
//                   name="password"
//                   value={loginObj.password}
//                   onChange={handleChanges}
//                   style={{
//                     padding: '10px',
//                     fontSize: '16px',
//                     border: '1px solid #ccc',
//                     borderRadius: '6px',
//                   }}
//                 />

//                 <span
//                   onClick={() => setShowPassword(!showPassword)}
//                   style={{
//                     position: "absolute",
//                     top: "50%",
//                     right: "10px",
//                     transform: "translateY(-50%)",
//                     cursor: "pointer",
//                     color: "#888",
//                   }}
//                 >
//                   {showPassword ? <FaEyeSlash /> : <FaEye />}
//                 </span>
//               </div> */}

//                             <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
//                                 <input
//                                     type={showPassword ? "text" : "password"}
//                                     placeholder="Password"
//                                     name="password"
//                                     value={loginObj.password}
//                                     onChange={handleChanges}
//                                     style={{
//                                         padding: "10px",
//                                         paddingRight: "40px",
//                                         fontSize: "16px",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "6px",
//                                         width: "100%",
//                                         boxSizing: "border-box"
//                                     }}
//                                 />
//                                 <span
//                                     onClick={() => setShowPassword(!showPassword)}
//                                     style={{
//                                         position: "absolute",
//                                         top: "50%",
//                                         right: "10px",
//                                         transform: "translateY(-50%)",
//                                         cursor: "pointer",
//                                         color: "#888"
//                                     }}
//                                 >
//                                     {showPassword ? <FaEyeSlash /> : <FaEye />}
//                                 </span>
//                             </div>
//                             <div style={{ textAlign: 'right' }}>
//                                 <span
//                                     onClick={() => setIsForgot(true)}
//                                     style={{
//                                         color: '#007bff',
//                                         fontSize: '14px',
//                                         textDecoration: 'none',
//                                         cursor: 'pointer',
//                                     }}
//                                 >
//                                     Forgot Password?
//                                 </span>
//                             </div>
//                             {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
//                             <button
//                                 type="submit"
//                                 style={{
//                                     backgroundColor: 'rgb(42 9 71)',
//                                     color: 'white',
//                                     fontWeight: 'bold',
//                                     padding: '12px',
//                                     border: 'none',
//                                     borderRadius: '6px',
//                                     cursor: 'pointer',
//                                 }}
//                                 disabled={isLoading}
//                             >
//                                 {isLoading ? 'Logging in...' : 'LOGIN'}
//                             </button>
//                         </form>
//                     </>
//                 )}

//                 {/* Forgot Password Form */}
//                 {isForgot && !isEmailSubmitted && (
//                     <form onSubmit={handleResetPassword}>
//                         <input
//                             type="email"
//                             placeholder="Enter your email"
//                             value={email}
//                             onChange={handleEmailChange}
//                             required
//                             style={{
//                                 padding: '10px',
//                                 fontSize: '16px',
//                                 border: '1px solid #ccc',
//                                 borderRadius: '6px',
//                                 marginBottom: '10px',
//                                 width: '100%',
//                             }}
//                         />
//                         <button
//                             type="submit"
//                             style={{
//                                 backgroundColor: 'rgb(42 9 71)',
//                                 color: 'white',
//                                 fontWeight: 'bold',
//                                 padding: '12px',
//                                 border: 'none',
//                                 borderRadius: '6px',
//                                 cursor: 'pointer',
//                                 width: '100%',
//                             }}
//                             disabled={loading}
//                         >
//                             {loading ? 'Sending...' : 'Submit'}
//                         </button>
//                         {message && (
//                             <div style={{ marginTop: '10px', color: message.includes('successfully') ? 'green' : 'red' }}>
//                                 {message}
//                             </div>
//                         )}
//                     </form>
//                 )}

//                 {/* Switch Between Login & Signup */}
//                 {!isForgot && (
//                     <div style={{ textAlign: 'center' }}>
//                         <div
//                             style={{
//                                 display: 'flex',
//                                 flexWrap: 'wrap',
//                                 gap: '20px',
//                                 justifyContent: 'center',
//                             }}
//                         >
//                             <img
//                                 src={wrapImage}
//                                 alt="wrap"
//                                 style={{ width: '100px', display: 'block' }}
//                             />
//                             <img
//                                 src={wrapImage}
//                                 alt="wrap"
//                                 style={{ width: '100px', display: 'block' }}
//                             />
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Auth;







import React, { useState, useEffect } from "react";
import image from "../../../images/aaaservices/h.png"; // Update your actual image path
import scannerImg from "../../../images/qr-code.png";
import wrapImage from "../../../images/aaaservices/food.avif"; // adjust path as per your folder structure
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./auth.css";

const Auth = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [showForgetPassword, setShowForgetPassword] = useState(false);
    const [isForgot, setIsForgot] = useState(false);
    const [loginObj, setLoginObj] = useState({
        userName: "",
        password: "",
    });
    const [hidePassword, setHidePassword] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [showLogin, setShowLogin] = useState(false);
    const [isSignup, setIsSignup] = useState(false);
    const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
    // const [loginStepStarted, setLoginStepStarted] = useState(false);
    const [emailCheckMessage, setEmailCheckMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    // Add this to your Auth component's useEffect
    useEffect(() => {
        const handleOpenLogin = () => {
            setShowLogin(true);
        };

        window.addEventListener('openLoginPanel', handleOpenLogin);

        return () => {
            window.removeEventListener('openLoginPanel', handleOpenLogin);
        };
    }, []);

    // ise change karke aisa karo 👇
    const [loginStepStarted, setLoginStepStarted] = useState(true);
    const handleResetPassword = async () => {
        if (!email) {
            alert("Please enter your email");
            return;
        }

        try {
            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/auth/vendor/reset-password?identifier=${encodeURIComponent(email)}`,
                {
                    method: "PUT",
                    headers: {
                        Accept: "*/*",
                    },
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Password reset failed");
            }

            // console.log("✅ Password reset success:", data);
            alert("Password reset link has been sent!");
        } catch (err) {
            console.error("❌ Error resetting password:", err);
            alert("Reset Password send to mailId!");
        }
    };
    const handleEmailCheck = async (e) => {
        e.preventDefault();
        const email = loginObj.emailId?.trim();

        if (!email) {
            alert("Please enter a valid email.");
            return;
        }

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/subscription/vendor-enquiries/get-email`,
                {
                    params: { emailId: email },
                }
            );

            console.log("✅ API Full Response:", response.data);
            const vendorData = response.data;

            if (vendorData?.vendorId) {
                localStorage.setItem("vendorId", vendorData.vendorId);
                alert("✅ Email verified and vendor ID stored.");
                // navigate("/foodladingpage");
                navigate("/landingpagesubscription");
            } else {
                console.warn("⚠️ No vendorId found in API response.");
                alert("Vendor not found. Please try again.");
            }
        } catch (error) {
            console.error("❌ Error during email check:", error.response?.data || error.message);
            alert("Failed to check email. Please try again.");
        }
    };

    const handleChange = (e) => {
        setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        const requestBody = {
            userName: loginObj.userName,
            emailId: loginObj.emailId,
            password: loginObj.password,
            mobileNumber: loginObj.mobileNumber,
            role: "ADMIN",
        };

        alert(`Role being sent: ${requestBody.role}`);

        const apiUrl =
            "http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/user/registration";

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            if (response.ok) {
                alert("Signup successful!");
                navigate("/home");
                setIsSignup(false);
                setIsForgot(false);
            } else {
                const result = await response.json();
                setError(result.message || "Signup failed");
            }
        } catch (error) {
            setError("Something went wrong. Please try again.");
        }

        setIsLoading(false);
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setLoginObj((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const url = `https://backend.maamaas.com/subscription/api/auth/login/vendor?identifier=${encodeURIComponent(
                loginObj.userName
            )}&password=${encodeURIComponent(loginObj.password)}`;

            const response = await fetch(url, {
                method: "POST",
                headers: { Accept: "*/*" },
                body: "", // matches curl -d ''
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Login failed");
            }

            console.log("✅ Login API response:", data);

            // Clear previous login data
            localStorage.clear();

            // Store fields
            localStorage.setItem("authToken", data.token || "");
            localStorage.setItem("refreshToken", data.refreshToken || "");
            localStorage.setItem("userId", data.userId?.toString() || "");
            localStorage.setItem("vendorId", data.vendorId?.toString() || "");
            localStorage.setItem("role", data.role || "");
            localStorage.setItem("employeRole", data.employeRole || "");
            localStorage.setItem("employeeId", data.employeeId?.toString() || "");

            // Store planTypes as JSON string
            if (Array.isArray(data.planTypes)) {
                localStorage.setItem("planTypes", JSON.stringify(data.planTypes));
                console.log("📦 Stored planTypes:", data.planTypes);
            } else {
                localStorage.setItem("planTypes", JSON.stringify([]));
            }

            // Store businessVerticals as JSON
            if (Array.isArray(data.businessVerticals)) {
                localStorage.setItem("businessVerticals", JSON.stringify(data.businessVerticals));
            } else {
                localStorage.setItem("businessVerticals", JSON.stringify([]));
            }

            // Optional: store full response
            localStorage.setItem("loginResponse", JSON.stringify(data));

            // Navigate after login
            // navigate("/foodladingpage");
            navigate("/fooddashboard");

        } catch (err) {
            console.error("❌ Login error:", err);
            setError("Login failed: " + err.message);
        } finally {
            setIsLoading(false);
        }
    };




    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const response = await fetch(
                "http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/forgot/password",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "*/*",
                    },
                    body: JSON.stringify({ identifier: email }),
                }
            );

            const text = await response.text();
            if (!response.ok) {
                throw new Error(text || "Something went wrong.");
            }

            setMessage("Password reset email sent successfully!");
            setShowPasswordFields(true);
            setIsEmailSubmitted(true);
        } catch (error) {
            setMessage(error.message || "Something went wrong. Try again later.");
        } finally {
            setLoading(false);
        }
    };

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const styles = {
        appContainer: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: "#2a0947",
        },
        navBar: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '15px 20px',
            backgroundColor: "#2a0947",
            zIndex: 1000,
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        },
        logo: {
            fontSize: '30px',
            fontWeight: 'bold',
            fontFamily: 'roboto',
            color: '#ffe124',
            margin: 0,
        },
        signInButton: {
            backgroundColor: 'rgb(255 225 36)',
            color: 'black',
            fontSize: '20px',
            fontFamily: 'Lato, sans-serif',
            fontWeight: 'bold',
            borderRadius: '16px',
            width: '90px',
            height: '40px',
            border: 'none',
            cursor: 'pointer',
        },
        contentContainer: {
            marginTop: '80px', // Push content below fixed navbar
            padding: '20px',
            flex: 1,
        },
        topText: {
            textAlign: 'center',
            marginBottom: '40px',
            marginTop: '20px',
        },
        topH2: {
            fontSize: '50px',
            marginBottom: '10px',
            fontWeight: 'bold',
            color: 'white',
        },
        topP: {
            fontSize: '50px',
            fontWeight: 'bold',
            color: 'white',
        },
        downloadBtn: {
            backgroundColor: '#ffe124',
            color: 'rgb(42 9 71)',
            padding: '12px 25px',
            fontSize: '20px',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: '0.3s ease',
            fontWeight: 'bold',
            marginTop: '20px',
        },
        mainContent: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '20px',
            marginBottom: '40px',
            flexWrap: 'wrap',
        },
        textSection: {
            flex: 1,
            minWidth: '280px',
        },
        textH3: {
            fontSize: '30px',
            marginBottom: '30px',
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'left',
        },
        textP: {
            fontSize: '20px',
            color: 'white',
            textAlign: 'left',
            fontWeight: 'bold',
            fontFamily: 'revert',
        },
        imageSection: {
            flex: 1,
            textAlign: 'center',
            marginTop: '40px',
        },
        image: {
            width: '100%',
            maxWidth: '600px',
            height: 'auto',
            borderRadius: '10px',
        },
        popupOverlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        popupInner: {
            background: 'white',
            padding: '30px',
            borderRadius: '10px',
            textAlign: 'center',
            position: 'relative',
            maxWidth: '400px',
            animation: 'slideUp 0.4s ease',
            zIndex: 1001,
        },
        closeBtn: {
            position: 'absolute',
            top: '10px',
            right: '15px',
            fontSize: '20px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
        },
        scannerImg: {
            width: '200px',
            height: 'auto',
            marginBottom: '15px',
        },
        loginPopup: {
            position: 'fixed',
            top: 75,
            right: showLogin ? '0' : '-100%',
            width: '100%',
            maxWidth: '400px',
            // height: '60vh',
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '40px 30px',
            boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.1)',
            transition: 'right 0.5s ease-in-out',
            zIndex: 999,
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            overflowY: 'auto',
        },
        // Responsive styles
        '@media (max-width: 1024px)': {
            topH2: {
                fontSize: '42px',
            },
            topP: {
                fontSize: '42px',
            },
            textH3: {
                fontSize: '26px',
            },
        },
        '@media (max-width: 768px)': {
            navBar: {
                padding: '10px 15px',
            },
            logo: {
                fontSize: '24px',
            },
            signInButton: {
                fontSize: '16px',
                width: '80px',
                height: '35px',
            },
            topH2: {
                fontSize: '32px',
            },
            topP: {
                fontSize: '32px',
            },
            textH3: {
                fontSize: '22px',
                marginLeft: '0',
                textAlign: 'center',
            },
            textP: {
                fontSize: '16px',
                textAlign: 'center',
            },
            mainContent: {
                flexDirection: 'column',
            },
            image: {
                height: 'auto',
            },
            loginPopup: {
                maxWidth: '90%',
                height: '70vh',
            },
        },
        '@media (max-width: 480px)': {
            topH2: {
                fontSize: '28px',
            },
            topP: {
                fontSize: '28px',
            },
            downloadBtn: {
                padding: '10px 20px',
                fontSize: '18px',
            },
            textH3: {
                fontSize: '20px',
            },
        },
    };

    return (
        <div style={styles.appContainer}>
            {/* Fixed Navigation Bar */}
            <div style={styles.navBar}>
                <div style={styles.logo}>MAAMAA'S</div>
                  <button
                    style={styles.signInButton}
                    onClick={() => setShowLogin(true)}
                >
                    Signin
                </button>
            </div>

            {/* Scrollable Content */}
            <div style={styles.contentContainer}>
                <div style={styles.topText}>
                    <p style={styles.topH2}>🌟 Welcome to Maamaas</p>
                    <p style={styles.topP}>The Digital Platform Built for Growth, Profit & Complete Business Control</p>
                    <button style={styles.downloadBtn} onClick={togglePopup}>
                        Download App
                    </button>

                    {showPopup && (
                        <div style={styles.popupOverlay}>
                            <div style={styles.popupInner}>
                                <button style={styles.closeBtn} onClick={togglePopup}>
                                    ×
                                </button>
                                <img
                                    src={scannerImg}
                                    alt="QR Code Scanner"
                                    style={styles.scannerImg}
                                />
                                <p>Scan the QR code to download the Maamaas App!</p>
                            </div>
                        </div>
                    )}
                </div>

                <div style={styles.mainContent}>
                    <div style={styles.textSection}>
                        <p style={styles.textH3}>
                            🚀 What Maamaas Brings to Your Business
                        </p>
                        <p style={{
                            textAlign: "justify",
                            fontSize: "18px",
                            lineHeight: "1.8",
                            fontFamily: "Roboto, sans-serif",
                            fontWeight: "400",
                            margin: "0 auto",
                            width: "90%",
                            color: "white",
                        }}>
                            In today's world, customers search, compare, and make decisions online before choosing a business.
                            If your business is not visible digitally, you are losing opportunities every single day — regardless of how good your products or services are.<br /><br />

                            Maamaas transforms your business into a powerful digital brand — effortlessly, affordably, and with complete control in your hands.
                            Build your online presence, reach new customers, manage daily operations, and grow faster with smart technology developed for real business needs.<br /><br />

                            <strong>Stronger Digital Identity | Higher Profit | Smarter Growth</strong>
                        </p>
                    </div>
                    <div style={styles.imageSection} className="image-lading-build">
                        <img src={image} alt="Digital Business Growth" style={styles.image} />
                    </div>
                </div>
            </div>




            {/* Login Popup */}
            <div style={{
                ...styles.loginPopup,
                right: showLogin ? '0' : '-100%',
            }}>
                <button
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '20px',
                        fontSize: '28px',
                        background: 'none',
                        border: 'none',
                        color: '#333',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        setShowLogin(false);
                        setIsForgot(false);
                        setIsSignup(false);
                    }}
                >
                    &times;
                </button>

                <p style={{
                    marginBottom: 0,
                    fontFamily: 'revert',
                    fontSize: '22px',
                    color: '#2a0947',
                    fontWeight: 'bold',
                }}>
                    WELCOME TO MAAMAA'S
                </p>

                {/* Login Form */}
                {!loginStepStarted && !isForgot && (
                    <>
                        <form onSubmit={handleEmailCheck} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <input
                                type="email"
                                placeholder="Enter your Email to Start"
                                name="emailId"
                                value={loginObj.emailId}
                                onChange={handleChange}
                                required
                                style={{
                                    padding: '10px',
                                    fontSize: '16px',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                }}
                            />
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: 'rgb(42 9 71)',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    padding: '12px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                }}
                            >
                                Check & Save
                            </button>
                        </form>

                        {emailCheckMessage && <p style={{ marginTop: '10px', color: 'green' }}>{emailCheckMessage}</p>}
                        <p style={{ marginTop: '10px', fontSize: '14px' }}>
                            Already signed up?{' '}
                            <span
                                onClick={() => {
                                    setIsSignup(false);
                                    setLoginStepStarted(true);
                                }}
                                style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                            >
                                Login here
                            </span>
                        </p>
                    </>
                )}

                {/* Login Form */}
                {!isForgot && loginStepStarted && (
                    <>
                        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <input
                                type="text"
                                placeholder="User ID"
                                name="userName"
                                value={loginObj.userName}
                                onChange={handleChanges}
                                style={{
                                    padding: '10px',
                                    fontSize: '16px',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                }}
                            />
                            {/* <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                <input
                  type={showPassword ? 'password' : 'text'}
                  placeholder="Password"
                  name="password"
                  value={loginObj.password}
                  onChange={handleChanges}
                  style={{
                    padding: '10px',
                    fontSize: '16px',
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                  }}
                />

                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#888",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div> */}

                            <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    name="password"
                                    value={loginObj.password}
                                    onChange={handleChanges}
                                    style={{
                                        padding: "10px",
                                        paddingRight: "40px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        width: "100%",
                                        boxSizing: "border-box"
                                    }}
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "10px",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#888"
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <span
                                    onClick={() => setIsForgot(true)}
                                    style={{
                                        color: '#007bff',
                                        fontSize: '14px',
                                        textDecoration: 'none',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Forgot Password?
                                </span>
                            </div>
                            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: 'rgb(42 9 71)',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    padding: '12px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                }}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Logging in...' : 'LOGIN'}
                            </button>
                        </form>
                    </>
                )}

                {/* Forgot Password Form */}
                {isForgot && !isEmailSubmitted && (
                    <form onSubmit={handleResetPassword}>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={handleEmailChange}
                            required
                            style={{
                                padding: '10px',
                                fontSize: '16px',
                                border: '1px solid #ccc',
                                borderRadius: '6px',
                                marginBottom: '10px',
                                width: '100%',
                            }}
                        />
                        <button
                            type="submit"
                            style={{
                                backgroundColor: 'rgb(42 9 71)',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '12px',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                width: '100%',
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Submit'}
                        </button>
                        {message && (
                            <div style={{ marginTop: '10px', color: message.includes('successfully') ? 'green' : 'red' }}>
                                {message}
                            </div>
                        )}
                    </form>
                )}

                {/* Switch Between Login & Signup */}
                {!isForgot && (
                    <div style={{ textAlign: 'center' }}>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                justifyContent: 'center',
                            }}
                        >
                            <img
                                src={wrapImage}
                                alt="wrap"
                                style={{ width: '100px', display: 'block' }}
                            />
                            <img
                                src={wrapImage}
                                alt="wrap"
                                style={{ width: '100px', display: 'block' }}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Auth;